// features/knowledge-base.fields.js

// Trade of Work / Business Type only matter for chapters targeting the CLIENT role — looks
// up the CLIENT role's id from the loaded dropdown options (userRoles)
// rather than hardcoding a role id, since tbl_user_role ids aren't
// guaranteed stable across environments/seed order.
const isClientRoleSelected = (formData, dependencies) => {
  const clientRole = (dependencies?.userRoles || []).find((r) => r.role === "CLIENT");
  if (!clientRole) return false;
  return (formData?.user_role_fids || []).includes(clientRole.id);
};

export const knowledgeBaseFields = [
  {
    name: "title",
    label: "Knowledge Base Title",
    type: "text",
    required: true,
    fullWidth: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    required: false,
    rows: 3,
    maxLength: 500,
    fullWidth: true,
  },
  {
    name: "order",
    label: "Display Order",
    type: "number",
    required: false,
    min: 0,
  },
  {
    name: "color_code",
    label: "Accent Color",
    type: "color",
    required: false,
  },
  {
    name: "user_role_fids",
    label: "Visible To Roles",
    type: "select",
    isMulti: true,
    required: true,
    is_api_data: true,
    optionsKey: "userRoles",
    optionLabel: "role",
    optionRelationKey: "user_roles",
    optionRelationValueKey: "id",
    fullWidth: true,
  },
  {
    name: "trade_of_work_fids",
    label: "Trade of Work",
    type: "select",
    isMulti: true,
    required: false, // conditionally required — enforced by knowledgeBaseValidation instead
    is_api_data: true,
    optionsKey: "tradeOfWorks",
    optionLabel: "trade_name",
    optionRelationKey: "trade_of_works",
    optionRelationValueKey: "id",
    fullWidth: true,
    hidden: (formData, dependencies) => !isClientRoleSelected(formData, dependencies),
  },
  {
    name: "business_type_fids",
    label: "Business Type",
    type: "select",
    isMulti: true,
    required: false, // conditionally required — enforced by knowledgeBaseValidation instead
    is_api_data: true,
    optionsKey: "businessTypes",
    optionLabel: "name",
    optionRelationKey: "business_types",
    optionRelationValueKey: "id",
    fullWidth: true,
    hidden: (formData, dependencies) => !isClientRoleSelected(formData, dependencies),
  },
  {
    name: "banner_image",
    label: "Banner Image",
    type: "file",
    required: false,
    maxSizeMB: 10,
    convertSizeKB: 200,
    acceptedTypes: ["image/jpeg", "image/png", "image/webp"],
    uploadDirectory: "knowledge-base",
    uploadProjectTitle: "knowledge-base-image",
  },
  {
    name: "is_activated",
    label: "Active",
    type: "boolean",
    uiType: "toggle",
    defaultValue: true,
    wrapperClassName: "flex gap-2 justify-start items-center",
  },
];
